export default "__VITE_ASSET__D_NFt4X6__"